<div class="user-settings-component-container" [style.min-height.px]="panelHeight">
  <div class="user-settings-form-field-row">
    <div class="user-settings-control control-label">Email Address</div>
    <div class="user-settings-control setting-control-50">
      <bfx-autoComplete
        size="sm"
        [(ngModel)]="emailAddress"
        [dropdown]="false"
        (completeMethod)="helperEmailAddress_validateEmailAddress($event)"
        autoHighlight="true"
        appendTo="body"
        delay="4"
        [minLength]="0"
        [maxlength]="100"
        [style]="{'width':'100%'}"
        (onFocus)="isEmailAddressFocused = true;"
        (onBlur)="isEmailAddressFocused = false;"
        [disabled]="!modifiable"
      >
      </bfx-autoComplete>
    </div>
    <div class="bfx-callout-warning-md" *ngIf="!isEmailAddressEmpty && !isEmailAddressValid">
      <i class="icon-warning"></i>
      <span>{{invalidEmailFormatMessage}}</span>
    </div>
  </div>
  <div class="user-settings-form-field-row">
    <div class="user-settings-control control-label">SMS Number</div>
    <div class="user-settings-control setting-control-50">
      <bfx-autoComplete
        size="sm"
        [(ngModel)]="smsNumber"
        [dropdown]="false"
        (completeMethod)="helperSmsNumber_validateSmsNumber($event)"
        autoHighlight="true"
        appendTo="body"
        delay="4"
        [minLength]="0"
        [style]="{'width':'100%'}"
        [scrollHeight]="menuScrollHeight"
        [maxlength]="50"
        (onFocus)="isSmsNumberFocused = true;"
        (onBlur)="isSmsNumberFocused = false;"
        [disabled]="!modifiable"
      >
      </bfx-autoComplete>
    </div>
    <div class="bfx-callout-warning-md" *ngIf="!isSmsNumberEmpty && !isSmsNumberValid">
      <i class="icon-warning"></i>
      <span>{{invalidSmsFormatMessage}}</span>
    </div>
  </div>
  <div class="notification_popup_container">
    <div class="notification_popup_container_popup_header">
      <div class="title-row">
        <div class="col-name">Event</div>
        <div class="col-email">Email</div>
        <div class="col-sms">SMS</div>
      </div>
    </div>
    <div class="notification_popup_container_popup_body">
      <div class="settings-row">
        <div
          class="col-name"
          [ngClass]="{'highlight': sendEmailMyOrdEnteredFg || sendSMSMyOrdEnteredFg }"
        >
          {{myOrdersEntryNotifications}}
        </div>
        <div class="col-email">
          <bfx-toggle
            [disabled]="disableEmailNotificationToggle"
            [(ngModel)]="sendEmailMyOrdEnteredFg"
            (change)="pageDataChanged($event)"
          ></bfx-toggle>
        </div>
        <div class="col-sms">
          <bfx-toggle
            [disabled]="disableSmsNotificationToggle"
            [(ngModel)]="sendSMSMyOrdEnteredFg"
            (change)="pageDataChanged($event)"
          ></bfx-toggle>
        </div>
      </div>
      <div class="settings-row">
        <div
          class="col-name"
          [ngClass]="{'highlight': sendEmailMyOrdModifiedFg || sendSMSMyOrdModifiedFg }"
        >
          {{myOrdersModifiedNotifications}}
        </div>
        <div class="col-email">
          <bfx-toggle
            [disabled]="disableEmailNotificationToggle"
            [(ngModel)]="sendEmailMyOrdModifiedFg"
            (change)="pageDataChanged($event)"
          ></bfx-toggle>
        </div>
        <div class="col-sms">
          <bfx-toggle
            [disabled]="disableSmsNotificationToggle"
            [(ngModel)]="sendSMSMyOrdModifiedFg"
            (change)="pageDataChanged($event)"
          ></bfx-toggle>
        </div>
      </div>
      <div class="settings-row">
        <div class="col-name" [ngClass]="{'highlight': sendEmailMyOrdFillFg || sendSMSMyOrdFillFg}">
          {{myOrdersFillNotifications}}
        </div>
        <div class="col-email">
          <bfx-toggle
            [disabled]="disableEmailNotificationToggle"
            [(ngModel)]="sendEmailMyOrdFillFg"
            (change)="pageDataChanged($event)"
          ></bfx-toggle>
        </div>
        <div class="col-sms">
          <bfx-toggle
            [disabled]="disableSmsNotificationToggle"
            [(ngModel)]="sendSMSMyOrdFillFg"
            (change)="pageDataChanged($event)"
          ></bfx-toggle>
        </div>
      </div>
      <div class="settings-row">
        <div
          class="col-name"
          [ngClass]="{'highlight': sendEmailMyOrdExpiryFg || sendSMSMyOrdExpiryFg}"
        >
          {{myOrdersExpiryNotifications}}
        </div>
        <div class="col-email">
          <bfx-toggle
            [disabled]="disableEmailNotificationToggle"
            [(ngModel)]="sendEmailMyOrdExpiryFg"
            (change)="pageDataChanged($event)"
          ></bfx-toggle>
        </div>
        <div class="col-sms">
          <bfx-toggle
            [disabled]="disableSmsNotificationToggle"
            [(ngModel)]="sendSMSMyOrdExpiryFg"
            (change)="pageDataChanged($event)"
          ></bfx-toggle>
        </div>
      </div>
      <div class="settings-row">
        <div
          class="col-name"
          [ngClass]="{'highlight': sendEmailMyOrdCanceledFg|| sendSMSMyOrdCanceledFg}"
        >
          {{myOrdersCanceledNotifications}}
        </div>
        <div class="col-email">
          <bfx-toggle
            [disabled]="disableEmailNotificationToggle"
            [(ngModel)]="sendEmailMyOrdCanceledFg"
            (change)="pageDataChanged($event)"
          ></bfx-toggle>
        </div>
        <div class="col-sms">
          <bfx-toggle
            [disabled]="disableSmsNotificationToggle"
            [(ngModel)]="sendSMSMyOrdCanceledFg"
            (change)="pageDataChanged($event)"
          ></bfx-toggle>
        </div>
      </div>
      <div class="settings-row">
        <div
          class="col-name"
          [ngClass]="{'highlight': sendEmailAnyOrderIFillFg || sendSMSAnyOrderIFillFg}"
        >
          {{myFilledFillNotifications}}
        </div>
        <div class="col-email">
          <bfx-toggle
            [disabled]="disableEmailNotificationToggle"
            [(ngModel)]="sendEmailAnyOrderIFillFg"
            (change)="pageDataChanged($event)"
          ></bfx-toggle>
        </div>
        <div class="col-sms">
          <bfx-toggle
            [disabled]="disableSmsNotificationToggle"
            [(ngModel)]="sendSMSAnyOrderIFillFg"
            (change)="pageDataChanged($event)"
          ></bfx-toggle>
        </div>
      </div>
    </div>
  </div>
</div>
